<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
// import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {nextTick} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar OS Saída",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Loader, PageHeader, Multiselect, Layout },
  data() {
    return {
      title: "Editar OS de Saída",
      items: [
        {
          text: "Ordens de Serviço",
          href: "/wmsossaida/list",
        },
        {
          text: "Editar OS de Saída",
          active: true
        }
      ],
      itenswmsos: {},
      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsListData: null,
      wmsOsData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },
      wmsOsDuplicadaData: null,
      desativaFuncoes: false,
      clienteData: {},
      movData: {
        tipoconf: 'I',
        defpalete: 'A',
        deflote: 'A',
        defserie: 'A',
        defvalid: 'A',

      },
      paleteData: {},
      wmsOsPedsData: {},
      wmsOsPedsES: {},
      wmsOsItemData: {},
      wmsOsItensData: [],
      wmsOsItensSepData: {},
      wmsOsItensSepPendData: [],
      wmsOsVolumesData: {},
      wmsOsVolumeData: {
        caixa: 1
      },
      optionsCaixas: {},

      selectedItem: null,
      submitted: false,
      errosValid: null,
      tipoVolume: 'A',
      showModalVolume: false,
      loadingWmsVolume: false,
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,
      showAssocRoma: false,
      showConfManual:false,
      showModalLote:false,
      showListConf:false,
      showListPed: false,
      showListConfig:false,
      dtListPesqRoma: null,
      disabledChave: false,
      flagAvulso: true,
      flagdispconf: null,
      autoImpressao: true,
      empresaData: {},
      tamanhoTela: 0,
      mudarConferencia: 'P',

      flagConferenciaCompos: false,
      flagConfFinalizada: false,
      wmsositemLotes: [],
      dtListLotes: [],
      itemResetLote: {
        endwms: "-",
        lote: "-",
      },
      flagProdutoSaldoWmsos: false,
      activeStep: 0,
      dtlistPesqEndereco: null,
      itensSepData: {},
      showModalRelatTFA: false,
      dtListRelatTFA: {},
      obrigInfoLote: false
    }
  },
  created() {
  },
  mounted() {
    console.log('mounted_wmsOs_editar_transp_0')
    this.tamanhoTela = window.innerWidth
    // const keys = useMagicKeys()

    // whenever(keys.alt_s, () => {
    //   this.$refs.produto.focus()
    // })
    //
    // whenever(keys.alt_r, () => {
    //   this.reiniciar()
    // })
    //
    // whenever(keys.alt_z, () => {
    //   this.finalizar()
    // })
    //
    // whenever(keys.alt_a, () => {
    //   this.efetivarSepPend2()
    // })

    let rota = this.$route.path

    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0) {
      this.carregarDados()

    } else {

      this.title = `Recebimento`
      this.updating = false
      this.flagAvulso = true
      this.autoImpressao = true

      this.carregaWmsOsAvulso()

    }
  },

  computed: {
    computedDisabledChave(){
      if(this.idData === 0){
        return false
      }else{
        return true
      }
    },

    filteredItens() {
      // Filtra itens com base no código do produto inserido
      return this.wmsOsItensData.filter(item =>
          item.produto === this.wmsOsItemData.produto
      );
    }
  },

  methods: {

    goToStep(step){
      // console.log('goToStep' , step)
      this.activeStep = step;

      nextTick(() => {
        if(step === 1) {
          // console.log('goToStep' , 1)
          if(this.movData.defpalete === 'A') {
            this.$refs.palete.focus()
          } else {
            this.$refs.endwms.focus()
          }
        } else if(step === 2){
          // console.log('goToStep' , 2)
          this.$refs.produto.focus()
        }
      })

    },

    selecionouLote(evt) {
      console.log('selecionouLote')
      // console.log(evt)

      if (evt !== null ) {
        let selecionados = Array.isArray(evt) ? evt : [evt]

        let lotesSelecionados = this.dtListLotes.filter(lote => selecionados.includes(lote.lote))

        // console.log('lotesSelecionados')
        // console.log(lotesSelecionados)

        const item = this.wmsOsItensData.find(i => i.produto_id === this.wmsOsItemData.produto_id)

        if (!item) {
          console.error('item não encontrado!')
        }

        item.endwms = lotesSelecionados.map(lote => lote.endwms)
        item.lote = lotesSelecionados.map(lote => lote.lote)
      }

      this.informouProduto()
      this.$refs.qtdlida.focus()
    },

    opcoesLotes(){
      // console.log('---------opcoesLotes---------')
      // console.log('wmsOsItemData: ' , this.wmsOsItemData["produto_id"])

      api.get(`${getBaseUrl()}api/pesqlotes`, {
        params: {
          produto_id: this.wmsOsItemData["produto_id"],
          qtd: this.wmsOsItemData["qtddisp"],
        },
      }).then((res) => {
        console.log("then axios pesqlotes");
        console.log(res.data);

        this.dtListLotes = res.data

        this.showModalLote = true
      })
    },

    confFinalizarParcialColetor(){
      console.log('conffinalizarParcial...')
      Swal.fire({
        position: "center",
        icon: 'info',
        title: 'Deseja Confirmar Finalização?',
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((value) => {
        console.log(value)
        if(value.isConfirmed){
          Swal.fire({
            position: "center",
            icon: 'info',
            title: 'Escolha o estoque de destino dos itens faltantes da conferência!',
            denyButtonText: "Avaria",
            confirmButtonText: "Falta",
            denyButtonColor: "#f6ae35",
            confirmButtonColor: "#ed4f4f",
            showDenyButton: true,
            showConfirmButton: true,
            reverseButtons:true
          }).then((value) => {
            console.log(value)
            this.selectedFinalizado = true
            this.showModalMsgUpdating = true
            this.showModalRelatTFA = false

            let endwmsfa = null
            if (value.isConfirmed) {
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                title: "Estoque escolhido: FALTA",
                timer: 1500
              })
              endwmsfa = 'FALTA'
            } else if (value.isDenied) {
              Swal.fire({
                icon: 'success',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                title: "Estoque escolhido: AVARIA",
                timer: 1500
              })
              endwmsfa = 'AVARIA'
            }

            this.updating = true
            api.post(`${getBaseUrl()}api/wmsosfinalsepentrada`, {
              'endwmsfa': endwmsfa ?? null,
              'listitensfa': this.dtListRelatTFA,
              'idwmsos': this.idData
            }).then((res) => {
              this.selectedFinalizado = false
              this.showModalMsgUpdating = false
              this.updating = false
              console.log('then axios finalizarParcial')
              console.log(res.data)

              let flag = res.data.success ?? false

              if (flag) {
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: 'Entrada gerada com sucesso!',
                  timer: 1500
                }).then(() => {
                  if(this.tamanhoTela >= 500){
                    this.atualizaPagina()
                  } else if (this.tamanhoTela < 500) {
                    this.recarregaWmsosAvulso()
                  }
                })
              } else {
                Swal.fire({
                  icon: 'error',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  text: res.data.message,
                  timer: 3000
                })
              }
              this.showListConfig = false
            }).catch((e) => {
              console.log('error...')
              console.log(e)
            })
          })
        } else if (value.isDismissed) {
          this.showModalRelatTFA = false

          Swal.fire({
            icon: 'info',
            position: 'top-end',
            showCancelButton: false,
            showConfirmButton: false,
            title: "Operação cancelada",
            timer: 1500
          })
        }
      })
    },

    efetivarSepPend2(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsosconfentrsepmuitos`, {
        'movItemSepPendData': this.wmsOsItensSepPendData,
        'idwmsos': this.idData,
        'configs': this.movData
      }).then((res) => {
        console.log('then axios separarPend')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))


          console.log('conferência salva')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.wmsOsItensSepData = {}
            this.wmsOsItensSepPendData = []
            this.flagConfFinalizada = res.data.finalizado

            if(this.flagConfFinalizada === false) {
              this.updatingListas = false
              this.updating = false
              this.carregarDados()

            } else {
              Swal.fire({
                position: "top-end",
                icon: "info",
                title: 'Seu pedido finalizou! Estamos processando a finalização.',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000
              })
              this.confSepararTodos()
            }
          })

      })
    },

    recarregaWmsosAvulso(){
      console.log('recarregando conferência avulsa...')

      this.idData = 0;
      this.$router.push(`/coletor/recebimentocoletor/0`).then((blankWmsos) => {
        window.open(blankWmsos, '_self')
        this.atualizaPagina()
        this.$refs.chave.focus()
      })
    },

    retornaParaWmsos(){
      console.log('retornaParaWmsos')
      if(this.idData > 0) {
        this.$router.replace(`/wmsos/entradaeditarnova/${this.idData}`)
      } else {
        this.$router.replace('/wmsossaida/list')
      }

    },

    carregaWmsOs(){
      console.log('carregaWmsOs')
      // console.log(`Chave / OS: ${this.movData.chave}`)

      if(this.idData > 0){
        this.goToStep(1)
        return
      }

      if(!this.movData.chave){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Ordem de Serviço inválida!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        api.post(`${getBaseUrl()}api/wmsosindividualentrada`, {
          'chave': this.movData.chave
        }).then((res) => {
          console.log('then axios wmsosindividualentrada')
          console.log(res.data)

          if(!res.data.success){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: res.data.message,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          }else{
            this.movData = res.data.wmsos
            this.idData = this.movData.id

            this.$router.push(`/coletor/recebimentocoletor/${this.movData.id}`)
            this.carregarDados()
          }
        }).catch(() => {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de Serviço inválida",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },

    confSepararTodos(){

      if(this.flagConfFinalizada === false) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Separar Todos Itens",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {

            // console.log(result.value)
            // console.log('vai')
            this.wmsOsItemData['idwmsos'] = this.idData
            this.updatingListas = true
            this.updating = true
            this.selectedFinalizado = true
            this.showModalMsgUpdating = true
            api.post(`${getBaseUrl()}api/wmsossepentrtodos`, {
              'movItemSepPendData': this.wmsOsItensSepPendData,
              'iddata': this.idData
            }).then((res) => {
              this.selectedFinalizado = false
              this.showModalMsgUpdating = false
              this.updatingListas = false
              this.updating = false
              console.log('then axios separar todos coletor')
              console.log(res.data)

              if (res.data.success === true) {
                Swal.fire({
                  icon: 'success',
                  position: 'center',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: res.data.message,
                  timer: 2500
                })

                this.atualizaPagina()
              } else {
                Swal.fire({
                  icon: 'error',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  text: res.data.message,
                  timer: 3000
                }).then(() => {

                  if (res.data.relatTFA) {
                    this.dtListRelatTFA = res.data.relatTFA
                    this.showModalRelatTFA = true
                  }
                })
              }
              this.showListConfig = false
            }).catch((e) => {
              console.log('error...')
              console.log(e)
            })
          }
        })
      } else {

        api.post(`${getBaseUrl()}api/wmsossepentrtodos`, {
          'iddata': this.idData
        }).then((res) => {
          this.updatingListas = false
          this.updating = false
          console.log('then axios separar todos coletor')
          console.log(res.data)

          if (res.data.success === true) {
            Swal.fire({
              icon: 'success',
              position: 'center',
              showCancelButton: false,
              showConfirmButton: false,
              title: res.data.message,
              timer: 2500
            })

            if(this.tamanhoTela >= 500){
              this.atualizaPagina()
            } else if (this.tamanhoTela < 500) {
              this.recarregaWmsosAvulso()
            }

          } else {
            Swal.fire({
              icon: 'error',
              position: 'top-end',
              showCancelButton: false,
              showConfirmButton: false,
              text: res.data.message,
              timer: 3000
            }).then(() => {

              if (res.data.relatTFA) {
                this.dtListRelatTFA = res.data.relatTFA
                this.showModalRelatTFA = true
              }
            })
          }
          this.showListConfig = false
        }).catch((e) => {
          console.log('error...')
          console.log(e)
        })

      }
    },

    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CF':
          result = 'Conferido'
          break
        case 'CO':
          result = 'Confirmado'
          break
        case 'EQ':
          result = 'Embarque'
          break
        case 'FN':
          result = 'Finalizado'
          break
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    atualizaPagina() {
      window.location.reload();
    },

    informouPalete() {
      console.log('informouPalete')
      console.log('codigo palete: ' + JSON.stringify(this.paleteData))

      api.get(`${getBaseUrl()}api/palidnew`, {
        params: {
          codigo: this.paleteData.codigo,
          empresa: this.movData.empresa,
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        if(res.data.success === true) {
          if(res.data.palete){
            this.paleteData.codigo = res.data.palete.codigo
            if(res.data.palete.endereco) {
              this.paleteData.endereco = res.data.palete.endereco
            }
          }
          nextTick(() => {
            this.$refs.endwms.focus()
          })

        } else {
          Swal.fire({
            position: "center",
            icon: "warning",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
      })

    },

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        // this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "wmsos", origem_id: this.wmsOsData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    escolheuEndereco() {
      console.log('escolheuEndereco')

      if(!this.paleteData.codigo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Campo Palete obrigatório, favor preencher.",
          showConfirmButton: false,
          timer: 2500
        })

        nextTick(() => {
          this.$refs.palete.focus()
        })
      } else {
        if (this.paleteData.endereco) {
          api.get(`${getBaseUrl()}api/wmsenddesc`, {
            params: {descdata: this.paleteData.endereco}
          }).then((res) => {
            console.log('then axios')
            console.log(res.data)

            if (res.data.success === true) {

              if (res.data.data || this.paleteData.endereco) {
                this.wmsOsItemData.endwms = res.data.data?.descricao ??
                    this.paleteData.endereco ?? null

                this.goToStep(2)
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "warning",
                  title: "Nenhum endereço definido, favor conferir endereço informado.",
                  showConfirmButton: false,
                  timer: 2500
                })
              }
            } else {
              Swal.fire({
                position: "center",
                icon: "warning",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2500
              })
            }
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Nenhum endereço definido, favor conferir endereço informado.",
            showConfirmButton: false,
            timer: 2500
          })
        }
      }
    },

    informouLote(){
      console.log('informouLote')

      this.wmsOsItemData.lote = this.itensSepData.lote

      if(this.movData.defserie === 'A') {
        this.$refs.serie.focus()
      } else if(this.movData.defserie !== 'A' && this.movData.defvalid === 'A'){
        this.$refs.valid.focus()
      } else {
        this.$refs.produto.focus()
      }
    },

    informouSerie(){
      console.log('informouSerie')

      this.wmsOsItemData.serie = this.itensSepData.serie

      if(this.movData.defserie === 'A') {
        this.$refs.valid.focus()
      } else {
        this.$refs.produto.focus()
      }
    },

    informouValid(){
      console.log('informouLote')

      this.wmsOsItemData.dtvalid = this.itensSepData.dtvalid
      this.$refs.produto.focus()
    },

    reiniciar() {
      console.log('reiniciar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          // console.log(result.value)
          // console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosreinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2_1')
            console.log(res.data)
            this.wmsOsItensSepData = {}
            this.wmsOsItemData.produto = ''

            this.wmsOsItensData = this.filtrarDisponiveis(res.data[0])

            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }

            this.wmsOsData = res.data[1]
            this.updatingListas = false
            this.showListConfig = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })

    },

    clicouProduto(data) {
      console.log('=============== clicouProduto ===============')
      console.log(data)
      this.showListConf = false

      this.wmsOsItemData.produto = data.produto
      this.wmsOsItemData.produto_id = data.produto_id
      this.wmsOsItemData.iditem = data.id
      this.wmsOsItemData.deflote = data.deflote

      this.obrigInfoLote = data.deflote

      if(this.obrigInfoLote && data.lote) {
        this.itensSepData.lote = data.lote
        this.wmsOsItemData.lote = this.itensSepData?.lote ?? null
      }

      if(data.serie) {
        this.itensSepData.serie = data.serie
        this.wmsOsItemData.serie = this.itensSepData.serie
      }

      if(data.dtvalid) {
        this.itensSepData.dtvalid = data.dtvalid
        this.wmsOsItemData.dtvalid = this.itensSepData.dtvalid
      }

      let compos_qtd = data.composicao?.qtd ?? null
      let compos_fator = data.composicao?.fator ?? null

      /*
      * Valida se conferência contém item composto
      */
      let qtddisp = 0
      let qtd = 0
      this.wmsOsItensData.forEach((item) => {

        if (item.id === this.wmsOsItemData.iditem) {
          //console.log(`item encontrado clicou produto: ${JSON.stringify(item)}`)

          if(item.desconsidsaldo){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Item com saldo desconsiderado para conferência!",
              text: "Item indisponível",
              showConfirmButton: false,
              timer: 2000
            })

            this.wmsOsItemData = {}
          }

          this.wmsOsItemData.compos_qtd = parseFloat(compos_qtd)
          this.wmsOsItemData.compos_fator = compos_fator
          qtddisp = item.qtddisp
          qtd = item.qtddisp
          this.wmsOsItemData.descprod = item.descprod
        }
      });

      this.wmsOsItemData.qtd = qtd
      this.wmsOsItemData.qtdlida = null

      this.wmsOsItemData.qtddisp = qtddisp

      console.log(`wmsOsItemData clicouProduto: ${JSON.stringify(this.wmsOsItemData)}`)

      if (this.wmsOsItemData.deflote === true && (!this.wmsOsItemData.lote || this.itensSepData.lote)) {
        this.$nextTick(() => {
          this.$refs.lote.focus()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.produto.focus()
        })
      }
    },

    clicouPedido(idPed) {
      console.log('clicouPedido')

      this.showListPed = false
      this.movData.chave = idPed;

      setTimeout(() => {
        this.$refs.chave.focus()
      }, 500)
    },

    informouProduto() {
      console.log('=============== informouProduto ===============')

      if(this.wmsOsData.status === 'SE' && this.wmsOsData.status === 'SE'){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Operação proibida",
          text: "Status de OS com separação finalizada!",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        let encontrouProd = false
        if(this.wmsOsItemData === null || (!this.wmsOsItemData.iditem && this.wmsOsItemData.produto)) {
          let qtddisp = 0
          let qtd = 0

          this.wmsOsItensData.forEach((value) => {
            if ((value.id === this.wmsOsItemData.iditem) || (this.wmsOsItemData.produto === value.produto) || (this.wmsOsItemData.produto === value.codbarra)) {
              console.log('primeiro caso')
              this.wmsOsItemData.produto = value.produto
              this.wmsOsItemData.produto_id = value.produto_id
              this.wmsOsItemData.descprod = value.descprod
              this.wmsOsItemData.qtd = value.qtddisp
              this.wmsOsItemData.iditem = value.id
              this.wmsOsItemData.deflote = value.deflote
              this.wmsOsItemData.lote = this.itensSepData.lote ?? value.lote ?? null
              this.wmsOsItemData.serie = this.itensSepData.serie ?? value.serie ?? null
              this.wmsOsItemData.dtvalid = this.itensSepData.dtvalid ?? value.dtvalid ?? null

              this.obrigInfoLote = value.deflote


              if (value.id === this.wmsOsItemData.iditem) {

                if(value.desconsidsaldo){
                  Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Item com saldo desconsiderado para conferência!",
                    text: "Item indisponível",
                    showConfirmButton: false,
                    timer: 2000
                  })

                  this.wmsOsItemData = {}
                }
                const composicao = value.composicao

                if(composicao){
                  this.wmsOsItemData.compos_qtd = parseFloat(composicao.qtd)
                  this.wmsOsItemData.compos_fator = composicao.fator
                }

                qtddisp = value.qtddisp
                qtd = value.qtddisp
                this.wmsOsItemData.descprod = value.descprod
              }

              this.wmsOsItemData.qtd = qtd
              this.wmsOsItemData.qtdlida = null
              this.wmsOsItemData.qtddisp = qtddisp

              this.selectedItem = value;

              if (this.movData.tipoconf === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  this.wmsOsItemData.qtdlida = 1
                }

                // console.log(`wmsOsItemData informouProduto: ${JSON.stringify(this.wmsOsItemData)}`)
                this.informouQtdLida2()
              } else {
                // this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
                this.abrirShowConfManual()

              }

              encontrouProd = true
            }
          });
        } else {
          console.log('segundo caso')

          this.wmsOsItensData.forEach((value) => {
            if(value.id === this.wmsOsItemData.iditem) {

              this.selectedItem = value;

              this.wmsOsItemData.lote = this.itensSepData.lote ?? value.lote ?? null
              this.wmsOsItemData.serie = this.itensSepData.serie ?? value.serie ?? null
              this.wmsOsItemData.dtvalid = this.itensSepData.dtvalid ?? value.dtvalid ?? null

              if (this.movData.tipoconf === 'A') {
                if(this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0){
                  console.log('quantidade produto composto')
                  this.wmsOsItemData.qtdlida = this.roundToDecimal(parseFloat(this.wmsOsItemData.compos_qtd), 4)
                }else{
                  console.log('quantidade automática')
                  this.wmsOsItemData.qtdlida = 1
                }

                this.informouQtdLida2()
              } else {
                // this.wmsOsItemData.qtdlida = value.qtddisp
                this.$refs.qtdlida.focus()
                this.abrirShowConfManual()

              }
              encontrouProd = true
            }
          });
        }
        if (!encontrouProd) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Produto Inválido",
            text: "Código inválido ou já finalizado!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    },

    informouQtdLida2() {
      console.log('=============== informouQtdLida2 ===============')
      // console.log(`qtdlida: ${this.wmsOsItemData.qtdlida}`)
      // console.log(`qtddisp: ${this.wmsOsItemData.qtddisp}`)
      // console.log(`wmsOsItemData: ${JSON.stringify(this.wmsOsItemData)}`)


      let passaSaldo = false
      let qtdLidaAtual = 0

      if (passaSaldo) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Quantidade indisponível, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        console.log('acumular lista para separar muitos')

        this.showConfManual = false

        let quantDisponivel = false

        for(const prod of this.wmsOsItensData) {
          if (prod.id === this.wmsOsItemData.iditem) {
            // console.log(`prod atual para baixa: ${JSON.stringify(prod)}`);

            if (!this.wmsOsItemData.lote && (prod.deflote && !prod.lote)) {
              this.opcoesLotes()
              return;
            }

            this.showModalLote = false

            qtdLidaAtual = this.roundToDecimal(parseFloat(this.wmsOsItemData.qtdlida), 4);

            if (prod.composicao) {
              if (prod.qtddisp >= 0) {
                console.log('baixa de produto composição...');

                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
                console.log(`qtddisp remaining: ${prod.qtddisp}`);

                // Validando se terminou de conferir o item atual
                if (prod.qtddisp < 0) {
                  prod.qtddisp = 0;
                  quantDisponivel = false;
                }
              }
            } else {
              console.log('baixa de produto comum...');

              if (prod.qtddisp >= qtdLidaAtual) {
                prod.qtdlida += qtdLidaAtual;
                prod.qtddisp = this.roundToDecimal((this.wmsOsItemData.qtd - qtdLidaAtual), 4);
                quantDisponivel = true;
              }
            }

            if (prod.qtddisp === 0) {
              this.wmsOsItensData.splice(this.wmsOsItensData.indexOf(prod), 1);
            }
            break;
          }
        }


        if (quantDisponivel === false) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Quantidade do produto indisponível para separação",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          if (this.wmsOsItemData.lote || this.wmsOsItemData.serie || this.wmsOsItemData.dtvalid) {
            console.log("LOTE INFORMADO", this.wmsOsItemData)

            const lote = this.wmsOsItemData.lote;
            // console.log(`informouQtdLida2 lote: ${lote}`)
            const endwms = this.wmsOsItemData.endwms ?? this.paleteData.endereco
            // console.log(`informouQtdLida2 endwms: ${endwms}`)
            const serie = this.wmsOsItemData.serie
            // console.log(`informouQtdLida2 serie: ${serie}`)
            const dtvalid = this.wmsOsItemData.dtvalid
            // console.log(`informouQtdLida2 dtvalid: ${dtvalid}`)
            const palete = this.paleteData.codigo
            // console.log(`informouQtdLida2 palete: ${palete}`)

            let existeProdPend = false;
            let existeProd = false;

            /* verificando se lote já existe em wmsOsItensSepPendData */
            this.wmsOsItensSepPendData.forEach((prod) => {
              //console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if( prod.iditem === this.wmsOsItemData.iditem && prod.lote === lote && prod.serie === serie &&
                  prod.dtvalid === dtvalid && prod.palete === palete && prod.endwms === endwms
                ) {
                existeProdPend = true;
                console.log('atualizando dados do item na lista wmsOsItensSepPendData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* verificando se lote já existe em in wmsOsItensSepData */
            this.wmsOsItensSepData.forEach((prod) => {
              console.log(`wmsOsItensSepPendData item atual: ${JSON.stringify(prod)}`)

              if( prod.iditem === this.wmsOsItemData.iditem && prod.lote === lote && prod.serie === serie &&
                  prod.dtvalid === dtvalid && prod.palete === palete && prod.endwms === endwms
                ) {
                existeProd = true;
                // console.log('atualizando dados do item na lista wmsOsItensSepData')

                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd) {
                  console.log('baixa qtd composição')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  console.log('baixa qtd comum')

                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /* Criando novos itens nas coleções */
            if (!existeProdPend) {
              console.log('criando novo item na lista wmsOsItensSepPendData')

              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'serie': serie,
                'dtvalid': dtvalid,
                'palete': palete,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }

            if (!existeProd) {
              console.log('criando novo item na lista wmsOsItensSepData')

              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'qtd': this.roundToDecimal(this.wmsOsItemData.qtdlida, 4),
                'lote': lote,
                'endwms': endwms,
                'serie': serie,
                'dtvalid': dtvalid,
                'palete': palete,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4)
              });
            }
            // console.log(`item criado na wmsOsItensSepPendData: ${JSON.stringify(this.wmsOsItensSepPendData)}`)
            // console.log(`item criado na wmsOsItensSepData: ${JSON.stringify(this.wmsOsItensSepData)}`)

          } else {
            // console.log("LOTE NÃO INFORMADO")

            const endwms = this.wmsOsItemData.endwms ?? this.paleteData.endereco
            const palete = this.paleteData.codigo

            let existeProdPend = false;
            let existeProd = false;

            this.wmsOsItensSepPendData.forEach((prod) => {
              if( prod.iditem === this.wmsOsItemData.iditem && prod.endwms === endwms && prod.palete === palete &&
                  prod.lote === this.wmsOsItemData.lote &&
                  prod.serie === this.wmsOsItemData.serie &&
                  prod.dtvalid === this.wmsOsItemData.dtvalid
              ) {
                existeProdPend = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });


            this.wmsOsItensSepData.forEach((prod) => {
              if( prod.iditem === this.wmsOsItemData.iditem && prod.endwms === endwms && prod.palete === palete &&
                  prod.lote === this.wmsOsItemData.lote &&
                  prod.serie === this.wmsOsItemData.serie &&
                  prod.dtvalid === this.wmsOsItemData.dtvalid
                ) {
                existeProd = true;
                if (this.flagConferenciaCompos && this.wmsOsItemData.compos_qtd > 0) {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                } else {
                  prod.qtd += qtdLidaAtual
                  prod.qtdlida += qtdLidaAtual
                  prod.qtdtotal -= qtdLidaAtual
                }
              }
            });

            /*Criando novos itens nas coleções */
            if (!existeProdPend) {
              this.wmsOsItensSepPendData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4),
                'lote': this.wmsOsItemData.lote ?? null,
                'endwms': this.wmsOsItemData.endwms ?? this.paleteData.endereco ?? null,
                'serie': this.wmsOsItemData.serie ?? null,
                'dtvalid': this.wmsOsItemData.dtvalid ?? null,
                'palete': this.paleteData.codigo ?? null,
              });
            }

            if (!existeProd) {
              this.wmsOsItensSepData.push({
                'iditem': this.wmsOsItemData.iditem,
                'descprod': this.wmsOsItemData.descprod,
                'imgs': '',
                'produto': this.wmsOsItemData.produto,
                'produto_id': this.wmsOsItemData.produto_id,
                'qtdlida': this.wmsOsItemData.qtdlida,
                'qtd': this.wmsOsItemData.qtdlida,
                'qtdtotal': this.roundToDecimal((this.wmsOsItemData.qtd - this.wmsOsItemData.qtdlida), 4),
                'lote': this.wmsOsItemData.lote ?? null,
                'endwms': this.wmsOsItemData.endwms ?? this.paleteData.endereco ?? null,
                'serie': this.wmsOsItemData.serie ?? null,
                'dtvalid': this.wmsOsItemData.dtvalid ?? null,
                'palete': this.paleteData.codigo ?? null,
              });
            }
          }

          //ordenando em desc e destacando o item atual para o topo
          const idItemAtual = this.wmsOsItemData.iditem

          const itemAtual = this.wmsOsItensSepData.find(item =>
              item.iditem === idItemAtual
          );
          const outrosItens = this.wmsOsItensSepData.filter(item =>
              !(item.iditem === idItemAtual)
          );

          if (outrosItens && outrosItens.length > 0) {
            outrosItens.sort((a, b) => b.iditem - a.iditem);

            this.wmsOsItensSepData = itemAtual ? [itemAtual, ...outrosItens] : outrosItens;
          } else if (itemAtual) {
            this.wmsOsItensSepData = [itemAtual]
          }

          /*console.log('wmsOsItensData >>> ' , this.wmsOsItensData)
          console.log('wmsOsItensSepData >>> ' , this.wmsOsItensSepData)
          console.log('wmsOsItensSepPendData >>> ' , this.wmsOsItensSepPendData)*/
          if (this.wmsOsItensData.length === 0) {
            this.efetivarSepPend2()
          }

          console.log('limpando wmsOsItemData')
          this.wmsOsItemData = {}

          console.log('retornando foco')
          this.$refs.produto.focus()
          console.log('===========================')
        }
      }
    },

    roundToDecimal(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.round(num * factor) / factor;
    },

    filtrarDisponiveis(arrayEntr) {
      //this.wmsOsItensData = res.data[6]
      console.log('filtrarDisponiveis')
      let listaFiltrada = []
      arrayEntr.forEach((value) => {
        if (value.qtddisp > 0) {
          /*
          * Verificando se existe composição novamente
          */
          if(value.composicao) {
            this.flagConferenciaCompos = true
          }

          listaFiltrada.push(value)
        }
      });
      return listaFiltrada
    },

    carregaWmsOsAvulso(){
      console.log('carregaWmsOsAvulso')

      api.get(`${getBaseUrl()}api/wmsosemabertos`, {
        params: {
          iddata: this.idData,
          origem: 'movcompra'
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)

        this.wmsOsPedsData = res.data[0]
        this.wmsOsPedsES = res.data[1]

      }).then(() => {
          setTimeout(() => {
            this.$refs.chave.focus()
          }, 500)
      })

    },

    carregarDados() {
      this.updating = true
      api.get(`${getBaseUrl()}api/wmsosentrada`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios carregar dados')
        console.log(res.data)

        if('success' in res.data && res.data.success !== true) {
          console.log('itens não foram completamente validados!')

          Swal.fire({
            position: "center",
            icon: "info",
            title: "Os itens para essa separação não foram reservados corretamente!",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            //Valida se existe saldo ou precisa de gerar um ajuste
            this.remetCnpj = res.data.remetcnpj
            if(res.data.erroTipo === 'saldo'){
              console.log('reserva de saldos pendentes')

              this.dtListErrorsProdutos = res.data.itensSemSaldo
              this.showModalErrosProdutos = true
            } else if(res.data.erroTipo === 'reserva'){
              console.log('reserva de saldos pendentes')

              this.showModalAssociaLotes = true
              this.dtListAssociaLote = res.data.defLotes
            }
          })

          this.updating = false
          return
        }



        this.wmsOsData = res.data[0]
        this.wmsOsListData = res.data[4]
        this.wmsOsVolumesData = res.data[1]

        let totalVols = 0;
        let pesoVols = 0;
        this.wmsOsVolumesData.forEach((value) => {
          totalVols += value.qtd
          pesoVols += value.peso
        });
        this.somaQtdVolumes = totalVols
        this.somaPesoVolumes = pesoVols

        // this.transpData = res.data[2]
        this.clienteData = res.data[3]
        this.movData = res.data[5]

        this.wmsOsItensData = this.filtrarDisponiveis(res.data[6])

        this.itenswmsos = res.data[6]
        this.wmsOsItensSepData = res.data[7]

        //Validando dados dadempresa
        if(!res.data[8]){
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Inconsistência nos dados da Empresa emissora do Wmsos",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }
        this.empresaData = res.data[8]

        this.wmsOsDuplicadaData = res.data[9]
        if (this.wmsOsDuplicadaData && this.wmsOsDuplicadaData.id) {
          console.log('desativando funções...')
          this.desativaFuncoes = true

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Ordem de serviço em duplicidade, excluir esta ou a id: " + this.wmsOsDuplicadaData.id + " antes de continuar.",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2500
          })
        }

        if (this.wmsOsItensData.length > 0) {
          this.wmsOsItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        if (this.wmsOsItensSepData.length > 0) {
          this.wmsOsItensSepData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
            }
          })
        }

        this.optionsCaixas = res.data[12]

        this.idData = this.wmsOsData.id
        this.title = `Recebimento`
        this.updating = false
      }).then(() => {

        if(this.wmsOsData.status === 'SE') {
          this.goToStep(0)
          nextTick(() => {
            this.$refs.chave.focus()
          })
        } else {
          this.goToStep(1)
          nextTick(() => {
            this.$refs.palete.focus()
          })
        }

      })
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    abrirShowConfManual() {
      console.log('abrirshowConfManual')

      this.showConfManual = true
    },

    onModalConfManual() {
      this.$refs.qtdlida.focus()
    },

    abrirShowListConf() {
      console.log('abrirShowListConf')

      if(this.idData === 0) {
        this.showListPed = true
      } else {
        this.showListConf = true
      }

    },

    abrirShowListConfig() {
      console.log('abrirShowListConfig')

      this.showListConfig = true
    },

    nomeStatusWms(stsIn) {
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
        case 'EL':
          result = 'Elaboração'
          break
        case 'AB':
          result = 'Elaboração'
          break
        case 'ES':
          result = 'Em Separação'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },

};
</script>
<template>

    <div class="row" v-if="tamanhoTela >= 500">
      <Layout>
        <div>
          <PageHeader :title="title" :items="items" :status="wmsOsData.status"/>

          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">

                <div class="d-flex mb-5"  style="margin-top: 12px">
                  <div class="d-flex justify-content-start">
                    <b-button variant="outline-primary" class="mx-2" :disabled="updating"
                              @click="recarregaWmsosAvulso">
                      <i class="bx bx-sync"></i>
                      Recarregar
                    </b-button>

                    <!--                  <b-button variant="outline-warning" class="mx-2" @click="reiniciar" v-if="(wmsOsData.status === 'ES' || wmsOsData.status === 'AB') && !desativaFuncoes">-->
                    <!--                    <i class="bx bx-sync font-size-16 align-middle me-2"></i>-->
                    <!--                    Reiniciar (alt + R)-->
                    <!--                  </b-button>-->

                    <b-button variant="outline-primary" class="mx-2" @click="efetivarSepPend2"
                              :disabled="wmsOsItensSepPendData.length < 1 || this.idData === 0 || wmsOsData.status === 'SE' || updating"
                    >
                      <i class="bx bx-save"></i>
                      Salvar
                    </b-button>

                    <b-button variant="outline-primary" :disabled="(activeStep !== 2 && this.idData > 0) ||  wmsOsData.status === 'SE' || updating"
                              class="mx-2" @click="abrirShowListConf">
                      <i class="bx bx-list-ul"></i>
                      Lista de {{ this.idData === 0 ? 'Pedidos' : 'Conferênica'}}
                    </b-button>

                    <b-button variant="outline-primary" :disabled="this.idData === 0 ||  wmsOsData.status === 'SE' || updating"
                              class="mx-2" @click="abrirShowListConfig">
                      <i class="bx bx-layer "></i>
                      Lista de Configuração
                    </b-button>

                    <b-button variant="outline-info" class="mx-2" @click="confSepararTodos" :disabled="wmsOsItensSepData.length < 1 || this.idData === 0 || wmsOsData.status === 'SE' || updating">
                      <i class="bx bx-copy-alt font-size-16 align-middle me-2"></i>
                      Finalizar OS Parcialmente
                    </b-button>

                    <b-button variant="outline-success" class="mx-2" @click="confSepararTodos" :disabled="wmsOsItensSepData.length < 1 || this.idData === 0 || wmsOsData.status === 'SE' || updating">
                      <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                      Finalizar Separação
                    </b-button>

                  </div>
                  <div class="ms-auto">
                    <button title="fullScreen" type="button" class="btn p-1 m-1 border-0 font-size-18" @click="initFullScreen">
                      <i class="bx bx-fullscreen"></i>
                    </button>
                    <button title="Ir para Espelho de conferência" class="btn col-1 p-1 m-1 border-0 font-size-18" @click="retornaParaWmsos" :disabled="updating">
                      <i class="bx bx-undo"></i>
                    </button>
                  </div>
                </div>

                <Loader v-if="updating" style="min-height: 400px;">
                </Loader>

                <div class="row" v-if="!updating">
                  <div class="col-xl-6">

                      <div class="card-body">

                        <form class="needs-validation">
                          <div id="step0" v-if="activeStep === 0" class="row mb-4" >
                            <div class="col-sm-12 mb-5" style="max-height: 400px; min-height: 400px;">
                              <div class="mb-3">
                                <label for="chave">Chave / Ordem de Serviço ({{this.idData > 0 ? 'ID: ' + this.idData : 'ID'}})</label>
                                <input
                                    id="chave"
                                    v-model="movData.chave"
                                    type="text"
                                    class="form-control compact-input"
                                    placeholder="Chave/OS ID"
                                    ref="chave"
                                    :disabled="computedDisabledChave"
                                    :class="{ 'is-invalid': submitted && !movData.chave }"
                                    @keydown.enter.prevent="carregaWmsOs"
                                />

                                <div v-if="submitted && !movData.chave" class="invalid-feedback">
                                  <span>Campo nome obrigatório, favor preencher.</span>
                                </div>
                              </div>
                            </div>

                            <div v-if="wmsOsData.status !== 'SE'" class="d-flex justify-content-center">
                              <button type="button" disabled class="btn-nav btn-back mx-2">
                                Voltar
                              </button>
                              <button type="button" class="btn-nav btn-next mx-2" @click="carregaWmsOs">
                                Próximo
                              </button>
                            </div>
                          </div>

                          <div id="step1" v-if="activeStep === 1" class="row mb-4">
                            <div class="col-sm-12 mb-5" style="max-height: 400px; min-height: 400px;">
                              <div class="mb-3">
                                <label for="palete">Palete</label>
                                <input
                                    id="palete"
                                    v-model="paleteData.codigo"
                                    type="text"
                                    class="form-control compact-input"
                                    placeholder="Palete"
                                    ref="palete"
                                    :disabled="movData.defpalete === 'I'"
                                    :class="{ 'is-invalid': submitted && !paleteData.codigo }"
                                    @keydown.enter.prevent="informouPalete"
                                />

                                <div v-if="submitted && !paleteData.codigo" class="invalid-feedback">
                                  <span>Campo Palete obrigatório, favor preencher.</span>
                                </div>
                              </div>

                              <div class="mb-2">
                                <label for="endereco">Endereço de Estoque</label>
                                <!--:disabled="movData.status !== 'EL'"-->
                                <input id="endereco" v-if="movData.tipoendwms === 'A'"
                                       ref="endwms"
                                       v-model="paleteData.endereco"
                                       type="text"
                                       class="form-control compact-input"
                                       placeholder="Definir Endereço"
                                       @keydown.enter.prevent="escolheuEndereco" />

                                <multiselect id="endereco" v-else
                                             ref="endwms"
                                             @search-change="pesqEndereco"
                                             @select="escolheuEndereco"
                                             v-model="paleteData.endereco"
                                             placeholder="Pesquisar endereços"
                                             :options="dtlistPesqEndereco"
                                             :searchable="true"
                                             label="descricao"
                                             track-by="descricao"
                                             value-prop="descricao">
                                  <template #option="slotProps">
                                    <div class="row">
                                      <div class="font-size-12">
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                                        <span class="mx-4" >
                              {{ slotProps.option.descricao }}
                            </span>
                                      </div>
                                      <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                                        {{ formatDateTime(slotProps.option.created_at) }}
                                      </div>
                                    </div>
                                  </template>
                                </multiselect>

                              </div>
                            </div>

                            <div v-if="wmsOsData.status !== 'SE'" class="d-flex justify-content-center">
                              <button type="button" class="btn-nav btn-back mx-2"  @click="goToStep(0)">
                                Voltar
                              </button>
                              <button type="button" class="btn-nav btn-next mx-2" @click="escolheuEndereco">
                                Próximo
                              </button>
                            </div>
                          </div>

                          <div id="step2" v-if="activeStep === 2" class="row">
                            <div class="col-sm-12" style="max-height: 400px; min-height: 400px;">
                              <div class="row">
                                <div class="col-6">
                                  <span>Palete: </span>
                                  <label v-if="paleteData.codigo" for="palete">
                                    {{  paleteData.codigo }}
                                  </label>
                                </div>
                                <div class="col-6">
                                  <span>Endereço: </span>
                                  <label v-if="paleteData.endereco" for="endereco">
                                    {{  paleteData.endereco }}
                                  </label>
                                </div>
                              </div>

                              <div class="mb-2">
                                <label for="produto">Código do Item</label>
                                <input id="produto"
                                       v-model="wmsOsItemData.produto"
                                       type="text"
                                       ref="produto"
                                       class="form-control compact-input"
                                       placeholder="Produto (alt + S)"
                                       @keypress.enter.prevent="informouProduto"
                                       :class="{ 'is-invalid': submitted && !wmsOsItemData.produto }"
                                />
                                <div v-if="submitted && !wmsOsItemData.produto" class="invalid-feedback">
                                  <span>Campo nome obrigatório, favor preencher.</span>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-6 mb-2">
                                  <label for="lote">Lote</label>
                                  <input
                                      id="lote"
                                      v-model="itensSepData.lote"
                                      type="text"
                                      ref="lote"
                                      class="form-control compact-input"
                                      placeholder="Definir Lote"
                                      :disabled="movData.deflote === 'I'"
                                      @keypress.enter="informouLote"/>
                                  <!--movData.status !== 'EL'-->
                                  <div v-if="obrigInfoLote">
                                    <span class="text-danger font-size-11">Lote obrigatório.</span>
                                  </div>
                                </div>

                                <div class="col-6 mb-2">
                                  <label for="serie">Serie</label>
                                  <input
                                      id="serie"
                                      v-model="itensSepData.serie"
                                      type="text"
                                      ref="serie"
                                      class="form-control compact-input"
                                      placeholder="Definir Serie"
                                      :disabled="movData.defserie === 'I'"
                                      @keypress.enter="informouSerie"/>
                                  <!--movData.status !== 'EL'-->
                                </div>

                                <div class="col-6 mb-2">
                                </div>

                                <div class="col-6 mb-2">
                                  <label for="valid">Validade:</label>
                                  <input
                                      id="valid"
                                      v-model="itensSepData.dtvalid"
                                      type="date"
                                      ref="valid"
                                      class="form-control compact-input"
                                      placeholder="Definir Valid"
                                      :disabled="movData.defvalid === 'I'"
                                      @change="informouValid"/>
                                  <!--movData.status !== 'EL'-->
                                </div>
                              </div>

                              <div class="row mt-5" v-if="selectedItem">

                                <div class="table-responsive">
                                  <table class="table align-middle mb-0 table-nowrap">
                                    <thead>
                                    <tr>
                                      <td style="padding: 0px 2px">Sku</td>
                                      <td class="text-danger" style="padding: 0px 2px">Pend.</td>
                                      <td class="text-success" style="padding: 0px 2px">Conf.</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr :key="selectedItem.id">
                                      <td>
                                        <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                                           @click="clicouProduto(selectedItem)">
                                          <h6 class="text-muted mb-0">{{ selectedItem.produto }} </h6>

                                        </a>
                                      </td>
                                      <td class="text-danger">{{ selectedItem.qtddisp }}</td>
                                      <td class="text-success">{{ selectedItem.qtdlida }}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div v-if="wmsOsData.status !== 'SE'" class="d-flex justify-content-center">
                              <button type="button" class="btn-nav btn-back mx-2" @click="goToStep(1)">
                                Voltar
                              </button>
                              <button type="button" class="btn-nav btn-next mx-2" @click="informouProduto">
                                Próximo
                              </button>
                            </div>
                          </div>
                        </form>


                      </div>




                  </div>

                  <div class="col-1 d-flex justify-content-center" v-if="(wmsOsItensSepData?.length > 0 || wmsOsItensData?.length > 0)">
                    <hr style="width: 1px;height: 400px;background-color: #000;border: none;margin: 0 10px;">
                  </div>

                  <div class="col-xl-4 ms-4" v-if="(wmsOsItensSepData?.length > 0 || wmsOsItensData?.length > 0)">
                    <div class="col-md-12 mt-2">
                      <label for="itensSeparados" class="mb-3">{{ wmsOsData.status === 'SE' ? 'Itens Conferidos:' : 'Itens à Conferir:'}}</label>
                      <div class="table-responsive" style="max-height: 360px; min-height: 360px; overflow-y: auto;">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                            <tr>
                              <th class="text-center">SKU</th>
                              <th class="text-end">Lidos</th>
                              <th class="text-end">Total</th>
                            </tr>
                          </thead>

                          <tbody v-if="wmsOsData.status === 'SE' && activeStep !== 2">
                            <template v-for="(data, index) in wmsOsItensSepData" :key="data.id">
                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.produto }}</td>
                                <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                                <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
                              </tr>

                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                                  Lote: {{ data.lote ?? 'Não Definido' }} / Serie: {{ data.serie ?? 'Não Definido' }}
                                </td>
                              </tr>

                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                                  {{ data.descprod.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                                </td>
                              </tr>
                            </template>
                          </tbody>

                          <tbody v-else>
                            <template v-for="(data, index) in wmsOsItensData.filter(item => item.qtdlida < item.qtd)" :key="data.id">
                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td v-if="activeStep === 2" style="padding-top: 3px; padding-bottom: 3px;">
                                  <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                                     @click="clicouProduto(data)">
                                    {{ data.produto }}
                                  </a>
                                </td>
                                <td v-else style="padding-top: 3px; padding-bottom: 3px;">
                                    {{ data.produto }}
                                </td>
                                <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                                <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
                              </tr>

                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                                  Lote: {{ data.lote ?? 'Não Definido' }} / Serie: {{ data.serie ?? 'Não Definido' }}
                                </td>
                              </tr>

                              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                                <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                                  {{ data.descprod.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>

    <div class="col-lg-12 full-height-wrapper" v-if="tamanhoTela < 500">

      <div class="card full-height-card">
        <div class="card-body full-height-body">

          <div class="row">
            <div class="d-flex col-10 align-items-baseline" style="position: fixed; top: 10px; left: 5px; z-index: 1000;">
              <h5 class="me-1">Recebimento</h5>
              <label :class="wmsOsData.status === 'SE' ? 'badge badge-soft-success' : 'badge badge-soft-warning'">
                {{ nomeStatusWms(wmsOsData.status) }}
              </label>
            </div>


            <button title="Retornar para WmsOS List" @click="retornaParaWmsos" class="btn col-1 p-1 m-1 border-0 font-size-16"
                    style="position: fixed; top: 0px; right: 5px; background-color: white; z-index: 1000;" :disabled="updating"
            >
              <i class="bx bx-undo"></i>
            </button>


            <div class="d-flex justify-content-between"  style="margin-top: 12px">

              <button class="btn p-1 m-1 border-0 font-size-16" @click="recarregaWmsosAvulso" :disabled="updating">
                <i class="bx bx-sync"></i>
              </button>

              <button type="button" :disabled="this.idData === 0 || wmsOsData.status === 'SE' || updating"
                      class="btn p-1 m-1 border-0 font-size-16" @click="efetivarSepPend2">
                <i class="bx bx-save"></i>
              </button>

              <button type="button" :disabled="(activeStep !== 2 && this.idData > 0) ||  wmsOsData.status === 'SE' || updating"
                      class="btn p-1 m-1 border-0 font-size-16" @click="abrirShowListConf">
                <i class="bx bx-list-ul"></i>
              </button>

              <button type="button" :disabled="this.idData === 0 ||  wmsOsData.status === 'SE' || updating"
                      class="btn p-1 m-1 border-0 font-size-16" @click="abrirShowListConfig">
                <i class="bx bx-layer "></i>
              </button>

              <button type="button" class="btn p-1 m-1 border-0 font-size-14" @click="initFullScreen">
                <i class="bx bx-fullscreen"></i>
              </button>

            </div>
          </div>

          <Loader v-if="updating" style="min-height: 400px;">
          </Loader>

          <form class="needs-validation" v-if="!updating">
            <div id="step0" v-if="activeStep === 0" class="row mb-4">
              <div class="col-sm-12 mb-5">
                <div class="mb-3">
                  <label for="chave">Chave / Ordem de Serviço ({{this.idData > 0 ? 'ID: ' + this.idData : 'ID'}})</label>
                  <input
                      id="chave"
                      v-model="movData.chave"
                      type="text"
                      class="form-control compact-input"
                      placeholder="Chave/OS ID"
                      ref="chave"
                      :disabled="computedDisabledChave"
                      :class="{ 'is-invalid': submitted && !movData.chave }"
                      @keydown.enter.prevent="carregaWmsOs"
                  />

                  <div v-if="submitted && !movData.chave" class="invalid-feedback">
                    <span>Campo nome obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div v-if="wmsOsItensSepData?.length > 0" class="col-md-12 mt-2">

                  <label for="itensSeparados" class="mb-1">Itens Conferidos:</label>
                  <div class="table-responsive" style="max-height: 230px; overflow-y: auto;">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th class="text-center">SKU</th>
                        <th class="text-end">Lidos</th>
                        <th class="text-end">Total</th>
                      </tr>
                      </thead>
                      <tbody>

                      <template v-for="(data, index) in wmsOsItensSepData" :key="data.id">
                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.produto }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
                        </tr>

                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                            Lote: {{ data.lote ?? 'Não Definido' }} / Serie: {{ data.serie ?? 'Não Definido' }}
                          </td>
                        </tr>

                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                            {{ data.descprod?.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                          </td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div v-if="wmsOsData.status !== 'SE'" class="nav-buttons">
                <button type="button" disabled class="btn-nav btn-back">
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="carregaWmsOs">
                  Próximo
                </button>
              </div>
            </div>

            <div id="step1" v-if="activeStep === 1" class="row mb-4">
              <div class="col-sm-12 mb-5">
                <div class="mb-3">
                  <label for="palete">Palete</label>
                  <input
                      id="palete"
                      v-model="paleteData.codigo"
                      type="text"
                      class="form-control compact-input"
                      placeholder="Palete"
                      ref="palete"
                      :disabled="movData.defpalete === 'I'"
                      :class="{ 'is-invalid': submitted && !paleteData.codigo }"
                      @keydown.enter.prevent="informouPalete"
                  />

                  <div v-if="submitted && !paleteData.codigo" class="invalid-feedback">
                    <span>Campo Palete obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div class="mb-2">
                  <label for="endereco">Endereço de Estoque</label>
                  <!--:disabled="movData.status !== 'EL'"-->
                  <input id="endereco" v-if="movData.tipoendwms === 'A'"
                         ref="endwms"
                         v-model="paleteData.endereco"
                         type="text"
                         class="form-control compact-input"
                         placeholder="Definir Endereço"
                         @keydown.enter.prevent="escolheuEndereco" />

                  <multiselect id="endereco" v-else
                               ref="endwms"
                               @search-change="pesqEndereco"
                               @select="escolheuEndereco"
                               v-model="paleteData.endereco"
                               placeholder="Pesquisar endereços"
                               :options="dtlistPesqEndereco"
                               :searchable="true"
                               label="descricao"
                               track-by="descricao"
                               value-prop="descricao">
                    <template #option="slotProps">
                      <div class="row">
                        <div class="font-size-12">
                        <span class="text-info">
                          {{ slotProps.option.id }}
                        </span>
                          <span class="mx-4" >
                            {{ slotProps.option.descricao }}
                          </span>
                        </div>
                        <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                          {{ formatDateTime(slotProps.option.created_at) }}
                        </div>
                      </div>
                    </template>
                  </multiselect>

                </div>

                <div v-if="wmsOsPedsES?.length > 0" class="col-md-12">

                  <div class="table-responsive" style="max-height: 120px; overflow-y: auto;">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Wms<br>OS</th>
                        <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">Nota<br>Fiscal</th>
                        <th class="text-end" style="white-space: normal; max-width: 5px; padding-top: 3px; padding-bottom: 3px;">Mov/<br>Orcto</th>
                      </tr>
                      </thead>
                      <tbody>

                      <template v-for="(data, index) in wmsOsPedsES" :key="data.id">
                        <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                          <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="clicouPedido(data.id)"
                            >
                              {{ data.id }}
                            </a>
                          </td>

                          <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">{{ data.numnf }}</td>
                          <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.origem_id }}</td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="nav-buttons">
                <button type="button" class="btn-nav btn-back" @click="goToStep(0)">
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="escolheuEndereco">
                  Próximo
                </button>
              </div>
            </div>

            <div id="step2" v-if="activeStep === 2" class="row">
              <div class="col-sm-12">

                <div class="row mb-2" v-if="selectedItem">

                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead>
                      <tr>
                        <td style="padding: 0px 2px">Sku</td>
                        <td class="text-danger" style="padding: 0px 2px">Pend.</td>
                        <td class="text-success" style="padding: 0px 2px">Conf.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="selectedItem.id">
                        <td>
                          <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                             @click="clicouProduto(selectedItem)">
                            <h6 class="text-muted mb-0">{{ selectedItem.produto }} </h6>

                          </a>
                        </td>
                        <td class="text-danger"><strong>{{ selectedItem.qtddisp }}</strong></td>
                        <td class="text-success"><strong>{{ selectedItem.qtdlida }}</strong></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <span>Palete: </span>
                    <label v-if="paleteData.codigo" for="palete">
                      {{  paleteData.codigo }}
                    </label>
                  </div>
                  <div class="col-6">
                    <span>Endereço: </span>
                    <label v-if="paleteData.endereco" for="endereco">
                      {{  paleteData.endereco }}
                    </label>
                  </div>
                </div>

                <div class="mb-2">
                  <label for="produto">Código do Item</label>
                  <input id="produto"
                         v-model="wmsOsItemData.produto"
                         type="text"
                         ref="produto"
                         class="form-control compact-input"
                         placeholder="Produto (alt + S)"
                         @keypress.enter.prevent="informouProduto"
                         :class="{ 'is-invalid': submitted && !wmsOsItemData.produto }"
                  />
                  <div v-if="submitted && !wmsOsItemData.produto" class="invalid-feedback">
                    <span>Campo obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 mb-2">
                    <label for="lote">Lote</label>
                    <input
                        id="lote"
                        v-model="itensSepData.lote"
                        type="text"
                        ref="lote"
                        class="form-control compact-input"
                        placeholder="Definir Lote"
                        :disabled="movData.deflote === 'I'"
                        @keypress.enter="informouLote"/>
                    <!--movData.status !== 'EL'-->
                    <div v-if="obrigInfoLote">
                      <span class="text-danger font-size-11">Lote obrigatório.</span>
                    </div>
                  </div>

                  <div class="col-6 mb-2">
                    <label for="serie">Serie</label>
                    <input
                        id="serie"
                        v-model="itensSepData.serie"
                        type="text"
                        ref="serie"
                        class="form-control compact-input"
                        placeholder="Definir Serie"
                        :disabled="movData.defserie === 'I'"
                        @keypress.enter="informouSerie"/>
                    <!--movData.status !== 'EL'-->
                  </div>

                  <div class="col-6 mb-2">
                  </div>

                  <div class="col-6 mb-2">
                    <label for="valid">Validade:</label>
                    <input
                        id="valid"
                        v-model="itensSepData.dtvalid"
                        type="date"
                        ref="valid"
                        class="form-control compact-input"
                        placeholder="Definir Valid"
                        :disabled="movData.defvalid === 'I'"
                        @change="informouValid"/>
                    <!--movData.status !== 'EL'-->
                  </div>
                </div>
              </div>

              <div class="nav-buttons">
                <button type="button" class="btn-nav btn-back" @click="goToStep(1)" >
                  Voltar
                </button>
                <button type="button" class="btn-nav btn-next" @click="informouProduto">
                  Próximo
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <b-modal title="Confer. Lote" v-model="showModalLote" centered hide-footer>
      <div class="col-md-12">

        <div class="col-12">
          <div class="mb-3">
            <label for="lote">Lotes</label>
            <select
                id="lotes"
                ref="selectLotes"
                class="form-select form-select-sm"
                style="padding: 5px 10px"
                v-model="wmsOsItemData.lote"
                @change="selecionouLote"
            >
              <option disabled :value="null">Selecione uma Lote</option>
              <option v-for="lotes in dtListLotes"
                      :key="lotes.lote"
                      :value="lotes.lote"
              >
                {{ lotes.lote }}
              </option>
            </select>
          </div>
        </div>

        <div class="row justify-content-around mt-3">
          <b-button class="col-5 btn-sm py-1" variant="light" @click="showModalLote = false">
            <i class="bx bx-block font-size-14 align-middle me-1"></i>
            <span class="small">Cancelar</span>
          </b-button>
          <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                    @click="informouQtdLida2()">
            <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
            <span class="small">Confirmar</span>
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Lista de Conferência" v-model="showListConf" centered hide-footer>
        <div class="col-md-12">

          <div class="table-responsive">
            <table class="table align-middle mb-0 table-nowrap">
              <thead class="table-light">
              <tr>
                <th>SKU</th>
                <th class="text-end">Lidos</th>
                <th class="text-end">Total</th>
              </tr>
              </thead>
              <tbody>

              <template v-for="(data, index) in wmsOsItensData.filter(item => item.qtdlida < item.qtd)" :key="data.id">
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td style="padding-top: 3px; padding-bottom: 3px;">
                    <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                       @click="clicouProduto(data)">
                      {{ data.produto }}
                    </a>
                  </td>

                  <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtdlida) }}</td>
                  <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
                </tr>
                <tr v-if="data.deflote" :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  Lote: {{ data.lote ?? 'Não Definido' }}
                  </td>
                </tr>
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                    {{ data.descprod.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod}}
                  </td>
                </tr>

              </template>
              </tbody>
            </table>
          </div>
        </div>

      </b-modal>

    <b-modal title="Configurações" v-model="showListConfig" centered hide-footer>
      <div class="col-md-12">

        <div class="col-12" v-if="wmsOsData.status === 'ES' || wmsOsData.status === 'AB'">
          <a class="dropdown-item text-primary text-center"
             @click="confSepararTodos"
             href="javascript: void(0);">
             Separar Todos
          </a>
        </div>

        <hr>

        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.tipoendwms">
            {{ movData.tipoendwms === 'A' ? 'End. Tipo Input' : 'End. Tipo Multiselect' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.tipoconf">
            {{ movData.tipoconf === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
          </b-form-checkbox>
        </div>
<!--        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.defpalete">
            {{ movData.defpalete === 'A' ? 'Definir Palete' : 'Desconsidera Palete' }}
          </b-form-checkbox>
        </div>-->
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.deflote">
            {{ movData.deflote === 'A' ? 'Definir Lote' : 'Desconsidera Lote' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.defserie">
            {{ movData.defserie === 'A' ? 'Definir Serie' : 'Desconsidera Serie' }}
          </b-form-checkbox>
        </div>
        <div class="col-12 d-flex justify-content-start">
          <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movData.defvalid">
            {{ movData.defvalid === 'A' ? 'Definir Validade' : 'Desconsidera Validade' }}
          </b-form-checkbox>
        </div>


      </div>

    </b-modal>

    <b-modal title="Lista de Conferência" v-model="showListPed" centered hide-footer>
      <div class="col-md-12">

        <div class="table-responsive">
          <table class="table align-middle mb-0 table-nowrap">
            <thead class="table-light">
            <tr>
              <th class="text-center" style="white-space: normal; max-width: 5px;padding-top: 3px; padding-bottom: 3px;">Wms<br>OS</th>
              <th class="text-center" style="white-space: normal; max-width: 5px;padding-top: 3px; padding-bottom: 3px;">Nota<br>Fiscal</th>
              <th class="text-center" style="white-space: normal; max-width: 5px; padding-top: 3px; padding-bottom: 3px;">Mov<br>Compra</th>
            </tr>
            </thead>
            <tbody>

            <template v-for="(data, index) in wmsOsPedsData" :key="data.id">
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                <td class="text-center" style="white-space: normal; max-width: 5px;padding-top: 3px; padding-bottom: 3px;">
                  <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                     @click="clicouPedido(data.id)"
                  >
                    {{ data.id }}
                  </a>
                </td>

                <td class="text-center" style="white-space: normal; max-width: 5px;padding-top: 3px; padding-bottom: 3px;">{{ data.codigo }}</td>
                <td class="text-center" style="white-space: normal; max-width: 5px;padding-top: 3px; padding-bottom: 3px;">{{ data.origem_id }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>

  </b-modal>

    <b-modal id="showModalRelatTFA" size="md" title="Relatório de TFA" v-model="showModalRelatTFA" centered hide-footer>
      <div class="col-md-12">

        <div class="table-responsive">
          <table class="table align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>ID Item</th>
                <th>Qtd. Disp.</th>
                <th>Qtd. Lida</th>
                <th>Qtd. Falta</th>
<!--                    <th>Ocorrencia</th>-->
<!--                    <th>Dt. TFA</th>-->
              </tr>
            </thead>
            <tbody>
              <template v-for="(data, index) in dtListRelatTFA" :key="data.idItem">
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td class="text-start">{{data.iditem}}</td>
                  <td class="text-start">{{data.qtddisp}}</td>
                  <td class="text-start">{{data.qtdlida}}</td>
                  <td class="text-start">{{data.qtdfalta}}</td>
<!--                      <td class="text-center">{{data.message}}</td>-->
<!--                      <td class="text-start">{{ formatDate(data.data) }}</td>-->
                </tr>
                <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                  <td colspan="4" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                    {{ data.data ? formatDate(data.data) + ' - ' + data.message : data.message}}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <div class="mt-2 p-2">
            <span class="text-danger">
              Deseja prosseguir com a confirmação da separação dos itens mesmo assim?
            </span>
          </div>

          <div class="text-end mt-3">
            <b-button variant="light" @click="showModalRelatTFA = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confFinalizarParcialColetor">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Confer. Manual" v-model="showConfManual" @shown="onModalConfManual" centered hide-footer>
    <div class="col-md-12">

      <!--                  Modal para colocar itens quando conf. for manual-->

      <div class="col-sm-6" v-if="selectedItem?.id">
        <div class="mb-3">
          <label for="codprod">Código do Item</label>
          <input id="codprod" v-model="selectedItem.produto" type="text" class="form-control"
                 disabled />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <label for="qtd">Qtd. Itens</label>
          <input id="qtd" v-model="wmsOsItemData.qtd" type="number" :disabled="true" class="form-control"
                 placeholder="Quantidade de Itens" />
        </div>

        <div class="col-6">
          <label for="qtdlida">Qtd. Disp.</label>
          <input id="qtdlida" ref="qtdlida" v-model="wmsOsItemData.qtdlida" type="number"
                 class="form-control" :disabled="movData.tipoconf === 'A'" @keypress.enter="informouQtdLida2()"
                 placeholder="Quantidade a ser lida" />
        </div>
      </div>

      <div class="row justify-content-around mt-3">
        <b-button class="col-5 btn-sm py-1" variant="light" @click="showConfManual = false">
          <i class="bx bx-block font-size-14 align-middle me-1"></i>
          <span class="small">Cancelar</span>
        </b-button>
        <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                  @click="informouQtdLida2()">
          <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
          <span class="small">Confirmar</span>
        </b-button>
      </div>
    </div>

  </b-modal>

</template>

<style scoped>
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
}

.full-height-card {
  height: 100%;
  margin-bottom: 0;
  border-radius: 0;
}

.full-height-body {
  height: 100%;
  overflow: hidden;
}

.compact-card {
  margin: 0;
  border-radius: 4px;
  box-shadow: none;
  border: 1px solid #e0e0e0;
}

.compact-body {
  padding: 4px 6px;
  margin: 0;
}

.compact-header {
  margin-bottom: 4px;
  font-size: 11px;
}

.compact-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 2px;
}

.btn-compact {
  background: none;
  border: 1px solid #ddd;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 12px;
  min-width: 28px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-compact:hover {
  background-color: #f5f5f5;
}

.compact-form {
  margin: 0;
}

.step-container {
  min-height: 100vh;
}

.field-group {
  margin-bottom: 8px;
}

.compact-label {
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 2px;
  display: block;
  color: #333;
}

.compact-input {
  font-size: 12px;
  padding: 4px 6px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 100%;
}

.compact-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0,123,255,.25);
  outline: none;
}

.compact-input.is-invalid {
  border-color: #dc3545;
}

.error-msg {
  font-size: 9px;
  color: #dc3545;
  margin-top: 2px;
}

.client-info {
  background: #f8f9fa;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 6px;
  font-size: 10px;
}

.client-name {
  font-weight: 600;
  display: block;
  color: #333;
  line-height: 1.2;
}

.client-detail {
  color: #666;
  font-size: 9px;
}

.item-info {
  background: #e8f4f8;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 8px;
  font-size: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
}

.item-label {
  font-weight: 600;
  color: #555;
}

.item-value {
  color: #333;
  font-weight: 500;
}

.nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1000;
  gap: 6px;
}

.btn-nav {
  flex: 1;
  padding: 6px 4px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid;
  background: white;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-back:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.btn-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-next {
  border-color: #28a745;
  color: #28a745;
}

.btn-next:hover {
  background-color: #28a745;
  color: white;
}
</style>
